'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { ArrowUpRight } from 'lucide-react';
import { useWebsitePagesCopy } from '@/lib/cadrino-landing/useWebsitePagesCopy';
import type { WebsitePageKey } from '@/lib/cadrino-landing/website-pages-copy';
import { cn } from '@/lib/utils';
import { ContentCard, Container, MotionBlock, Section, SectionHeader, CardKicker, CardTitle, CardText, cardGrid3Class } from './shared';
const pageOrder: WebsitePageKey[] = ['product', 'partners', 'security', 'integrations'];
export function ExplorePagesSection() {
  const $ = _c(11);
  const c = useWebsitePagesCopy();
  const title = c.nav.home === "Po\u010Detna" ? "Istra\u017Eite detaljnije" : "Explore further";
  const subtitle = c.nav.home === "Po\u010Detna" ? "Ako \u017Eelite vi\u0161e od landing pregleda, ovde su klju\u010Dne stranice koje obja\u0161njavaju proizvod, partner integracije, Cadrino HR i sigurnost." : "If you want more than the landing overview, these key pages explain product, partner integrations, Cadrino HR, and security.";
  let t0;
  if ($[0] !== subtitle || $[1] !== title) {
    t0 = <MotionBlock><SectionHeader title={title} subtitle={subtitle} /></MotionBlock>;
    $[0] = subtitle;
    $[1] = title;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== c.nav || $[4] !== c.pages) {
    t1 = pageOrder.map((pageKey, index) => {
      const page = c.pages[pageKey];
      const href = `/${pageKey}`;
      return <MotionBlock key={pageKey} delay={index * 0.04}><Link href={href} className="group block h-full"><ContentCard className={cn("transition-all", "group-hover:border-slate-300 group-hover:shadow-md")}><CardKicker>{c.nav[pageKey]}</CardKicker><CardTitle className="mt-3">{page.teaser.title}</CardTitle><CardText className="mt-3 flex-1">{page.teaser.description}</CardText><span className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-cadrino-primary group-hover:gap-2">{page.teaser.cta}<ArrowUpRight className="h-4 w-4 shrink-0" aria-hidden={true} /></span></ContentCard></Link></MotionBlock>;
    });
    $[3] = c.nav;
    $[4] = c.pages;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = <div className={cardGrid3Class}>{t1}</div>;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t0 || $[9] !== t2) {
    t3 = <Section><Container>{t0}{t2}</Container></Section>;
    $[8] = t0;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}